export enum ProjectTypeEnum {
  PRE_SALES = "pre_sales",
  POST_SALES = "post_sales",
}

export enum FastPayStatusEnum {
  NOT_APPLICABLE = "N/A",
  PENDING_CLOSER = "Pending Closer",
  PENDING_PAYMENTS = "Pending Payments",
  PAID = "Paid",
}

export enum PrimaryContactEnum {
  SETTER = "seller",
  CLOSER = "closer",
  BOTH = "both",
}
